document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('[data-aq-page]');
  if (!page) return;

  var options = Array.prototype.slice.call(page.querySelectorAll('[data-aq-option]'));
  var slots = Array.prototype.slice.call(document.querySelectorAll('[data-aq-slot]'));
  if (!options.length || !slots.length) return;

  for (var i = options.length - 1; i > 0; i -= 1) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = options[i];
    options[i] = options[j];
    options[j] = temp;
  }

  slots.forEach(function (slot, index) {
    var option = options[index];
    if (!option) return;
    var image = slot.querySelector('img');
    slot.href = option.dataset.url;
    image.src = option.dataset.image;
    image.alt = option.dataset.title;
    slot.querySelector('[data-aq-title]').textContent = option.dataset.title;
    slot.querySelector('[data-aq-vendor]').textContent = option.dataset.vendor || 'AccuQuilt';
    slot.hidden = false;
    window.requestAnimationFrame(function () { slot.classList.add('is-ready'); });
  });
});
